export const questions = [
  {
    question: "What kind of activity makes you lose track of time?",
    options: [
      "Solving logical or technical problems",
      "Listening to people and helping them",
      "Creating something — art, music, design",
      "Reading, writing, or analyzing texts",
      "Cooking or experimenting with recipes",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { psychologist: 10, teacher: 5, doctor: 5 },
      { artist: 10 },
      { lawyer: 7, journalist: 7, economist: 5 },
      { chef: 10 },
    ],
  },

  {
    question: "How do you usually react when someone asks for help?",
    options: [
      "I explain the whole process clearly",
      "I listen carefully and try to understand",
      "I quickly propose solutions",
      "I give logical arguments to guide them",
      "I draw or visualize things for clarity",
    ],
    points: [
      { teacher: 10 },
      { psychologist: 10 },
      { entrepreneur: 7, programmer: 5 },
      { lawyer: 10 },
      { artist: 7, engineer: 5 },
    ],
  },

  {
    question: "Which type of tasks do you enjoy the most?",
    options: [
      "Technical or logical tasks",
      "Tasks involving people",
      "Creative activities",
      "Financial or organizational tasks",
      "Activities that require physical presence",
    ],
    points: [
      { programmer: 10, engineer: 8 },
      { teacher: 7, psychologist: 7, doctor: 5 },
      { artist: 10 },
      { economist: 10 },
      { police_officer: 10 },
    ],
  },

  {
    question: "How would you prefer to spend a free day?",
    options: [
      "Exploring technology or building something",
      "Talking to someone or reading psychology",
      "Visiting museums or creating art",
      "Organizing things or analyzing information",
      "Cooking something new",
    ],
    points: [
      { programmer: 10, engineer: 5 },
      { psychologist: 8, teacher: 5 },
      { artist: 10 },
      { economist: 5, lawyer: 5 },
      { chef: 10 },
    ],
  },

  {
    question: "How do you approach a difficult problem?",
    options: [
      "I break it into smaller logical parts",
      "I try to understand the feelings involved",
      "I search for unconventional ideas",
      "I look for the rules or principles behind it",
      "I test practical solutions immediately",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { psychologist: 10 },
      { artist: 10 },
      { lawyer: 10 },
      { entrepreneur: 7, chef: 5 },
    ],
  },

  {
    question: "In a group project, which role do you take automatically?",
    options: [
      "The technical planner",
      "The explainer/teacher",
      "The creative designer",
      "The analyst who asks logical questions",
      "The leader who coordinates the group",
    ],
    points: [
      { programmer: 10, engineer: 10 },
      { teacher: 10 },
      { artist: 10 },
      { lawyer: 7, economist: 5 },
      { entrepreneur: 10 },
    ],
  },

  {
    question: "Which type of knowledge attracts you the most?",
    options: [
      "Exact sciences and technology",
      "Psychology and human behavior",
      "Art, aesthetics, creativity",
      "Rules, structures, and law",
      "Finance and economics",
    ],
    points: [
      { programmer: 8, engineer: 10 },
      { psychologist: 10, teacher: 5 },
      { artist: 10 },
      { lawyer: 10 },
      { economist: 10 },
    ],
  },

  {
    question: "What motivates you the most in your work?",
    options: [
      "Solving something challenging",
      "Helping people feel better",
      "Creating something unique",
      "Proving something logically",
      "Organizing or optimizing something",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { doctor: 10, psychologist: 7 },
      { artist: 10 },
      { lawyer: 10 },
      { economist: 7, entrepreneur: 7 },
    ],
  },

  {
    question: "How do you prefer to communicate?",
    options: [
      "With logic and clarity",
      "Calm and empathetic",
      "Creative and expressive",
      "Direct and argumentative",
      "Short and efficient",
    ],
    points: [
      { programmer: 5, engineer: 5, economist: 5 },
      { psychologist: 10, teacher: 7, doctor: 5 },
      { artist: 10 },
      { lawyer: 10 },
      { entrepreneur: 7, police_officer: 7 },
    ],
  },

  {
    question: "What type of satisfaction do you seek from your work?",
    options: [
      "Seeing something I built work",
      "Seeing people feel helped",
      "Expressing creativity",
      "Winning arguments with logic",
      "Creating order and structure",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { doctor: 10, psychologist: 7 },
      { artist: 10 },
      { lawyer: 10 },
      { economist: 7, police_officer: 5 },
    ],
  },

  {
    question: "How do you prefer to learn new things?",
    options: [
      "By experimenting technically",
      "By discussing with people",
      "By exploring creatively",
      "Through rules and clear examples",
      "By repeating practical tasks",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { psychologist: 7, teacher: 7 },
      { artist: 10 },
      { lawyer: 7, economist: 7 },
      { chef: 10, police_officer: 5 },
    ],
  },

  {
    question: "What frustrates you the most?",
    options: [
      "Lack of logic",
      "Lack of empathy",
      "Lack of creativity",
      "Breaking rules",
      "Chaos",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { psychologist: 10 },
      { artist: 10 },
      { police_officer: 10, lawyer: 7 },
      { economist: 10 },
    ],
  },

  {
    question: "How do you react to a chaotic situation?",
    options: [
      "I look for the technical cause",
      "I calm people down",
      "I find a creative workaround",
      "I organize everything by rules",
      "I take charge and coordinate",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { psychologist: 10, doctor: 7 },
      { artist: 10 },
      { police_officer: 10, lawyer: 7 },
      { entrepreneur: 10 },
    ],
  },

  {
    question: "What work environment do you prefer?",
    options: [
      "A quiet computer-based workspace",
      "A social environment with people",
      "A colorful, creative space",
      "A structured, rule-based environment",
      "A dynamic environment with movement",
    ],
    points: [
      { programmer: 10 },
      { teacher: 7, psychologist: 7, doctor: 5 },
      { artist: 10 },
      { lawyer: 10, economist: 7 },
      { police_officer: 10, chef: 5 },
    ],
  },

  {
    question: "What kind of responsibility fits you best?",
    options: [
      "Solving technical problems",
      "Helping people",
      "Creating something beautiful",
      "Analyzing and deciding correctly",
      "Coordinating people and tasks",
    ],
    points: [
      { programmer: 10, engineer: 7 },
      { doctor: 10, psychologist: 7 },
      { artist: 10 },
      { lawyer: 10, economist: 7 },
      { entrepreneur: 10, police_officer: 5 },
    ],
  },
  {
    question: "What type of projects excite you the most?",
    options: [
      "Building or designing structures",
      "Solving scientific mysteries",
      "Performing or expressing emotions",
      "Repairing or assembling machines",
      "Promoting ideas creatively to people",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "How do you react when faced with a new challenge?",
    options: [
      "I draft a plan or blueprint",
      "I research and analyze deeply",
      "I use body language and expression",
      "I take things apart to understand them",
      "I consider how to present it attractively",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "Which school subject did you enjoy the most?",
    options: [
      "Geometry and design",
      "Biology or chemistry",
      "Drama or literature",
      "Physics or mechanics",
      "Business or marketing",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "What do you value most in a job?",
    options: [
      "Creating functional structures",
      "Discovering how life works",
      "Expressing emotions and telling stories",
      "Fixing things and being hands-on",
      "Understanding people’s needs",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "What kind of thinking comes naturally to you?",
    options: [
      "Spatial and structural thinking",
      "Analytical and experimental thinking",
      "Emotional and expressive thinking",
      "Mechanical and technical thinking",
      "Persuasive and strategic thinking",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "How do you usually express yourself?",
    options: [
      "Through diagrams or designs",
      "By explaining scientific ideas",
      "Through voice, movement, or acting",
      "By fixing or modifying objects",
      "Through creative marketing or visuals",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "What role fits you in a creative team?",
    options: [
      "The planner who sketches ideas",
      "The researcher who provides facts",
      "The performer who brings ideas to life",
      "The builder who executes physically",
      "The promoter who presents the project",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "What type of environment helps you focus?",
    options: [
      "A calm place where I can design",
      "A lab with tools for experiments",
      "A stage or expressive setting",
      "A workshop with equipment",
      "A dynamic environment with people",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "How do you handle mistakes?",
    options: [
      "I redesign and adjust the structure",
      "I retest and analyze data",
      "I turn them into creative expression",
      "I repair and improve the mechanism",
      "I rethink the strategy and messaging",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },

  {
    question: "What would make you proud of your career?",
    options: [
      "Seeing a building I designed being used",
      "Contributing to scientific discoveries",
      "Playing an impactful role",
      "Fixing something important for someone",
      "Helping a brand or idea grow",
    ],
    points: [
      { architect: 10 },
      { biologist: 10 },
      { actor: 10 },
      { mechanic: 10 },
      { marketing_specialist: 10 },
    ],
  },
];
